import React from "react";
import { useParams } from "react-router-dom";
import MarstickExtensionInstallSDK from "@/components/extensions/MarstickExtensionInstallSDK";
import BrowserChoiceGrid from "@/components/extensions/BrowserChoiceGrid";
import ExtensionFeatureGrid from "@/components/extensions/ExtensionFeatureGrid";
import ExtensionPrivacyCard from "@/components/extensions/ExtensionPrivacyCard";
import ExtensionEnterpriseSummary from "@/components/extensions/ExtensionEnterpriseSummary";

const allowed = new Set(["chrome", "edge", "firefox", "safari"]);

export default function ExtensionsPage() {
  const { lang, browserSlug } = useParams();
  const prefix = lang ? `/${lang}` : "";
  const forcedBrowser = allowed.has(browserSlug) ? browserSlug : null;
  return (
    <main className="maritime-container py-8 md:py-14">
      <section className="rounded-[2rem] border border-white/60 bg-slate-950 p-5 text-white shadow-2xl shadow-ocean/20 md:p-8">
        <p className="text-xs font-black uppercase tracking-[0.24em] text-cyan-200">Marstick Weather Extension Installer SDK</p>
        <h1 className="mt-3 max-w-4xl font-heading text-4xl font-black tracking-tight !text-white md:text-6xl">Install Marstick Weather Extension</h1>
        <p className="mt-4 max-w-3xl text-base leading-7 text-cyan-50/85 md:text-lg">Fast maritime weather and safety tools directly from your browser.</p>
      </section>
      <div className="mt-6"><MarstickExtensionInstallSDK forcedBrowser={forcedBrowser} /></div>
      <BrowserChoiceGrid prefix={prefix} />
      <ExtensionFeatureGrid />
      <ExtensionPrivacyCard />
      <ExtensionEnterpriseSummary prefix={prefix} />
    </main>
  );
}